import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { getAssignedAssetFields, type EmployeeAssignedAsset } from "types/employee";

type Props = {
  asset: EmployeeAssignedAsset;
  /** Tighter spacing for table cells. */
  dense?: boolean;
};

export default function EmployeeAssignedAssetSummary({ asset, dense }: Props) {
  const f = getAssignedAssetFields(asset);
  return (
    <Box sx={{ mb: dense ? 0.75 : 1.5 }}>
      <RouterLink to={`/assets/${asset.uuid}/edit`}>
        <Typography variant="body2" color="primary" component="span" sx={{ fontWeight: 500 }}>
          View asset
        </Typography>
      </RouterLink>
      <Typography variant="caption" display="block" color="text.secondary" sx={{ lineHeight: 1.4 }}>
        Device type: {f.deviceType}
        <br />
        Manufacturer: {f.manufacturer}
        <br />
        Model: {f.model}
        <br />
        Serial: {f.serial}
      </Typography>
    </Box>
  );
}
